<template>
  <div class="container mescroll-touch">
    <Questionnaire :questionId="questionId" :sourceType="sourceType" :sourceId="sourceId" />
  </div>
</template>

<script>
import Questionnaire from '../../components/questionnaire.vue';
export default {
  data() {
    return {}
  },
  computed: {
    questionId() {
      return this.$route.query.questionId;
    },
    sourceType() {
      return this.$route.query.sourceType
    },
    sourceId() {
      return this.$route.query.sourceId
    }
  },
  components: {
    Questionnaire
  },
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
</style>